import React, { useCallback, useState } from 'react';

import { throttle } from 'lodash';

import { useMediaElementListener } from 'services/hooks/useMediaElementListener';

import { ElapsedAndTotalTimeContainer } from './ElapsedAndTotalTime.style';
import { getElapsedAndTotalTime } from '../Mp3KbpPlayerControls/utils';

interface Props {
  songDuration: number | null;
  videoElement: HTMLVideoElement;
}

const ELAPSED_TIME_MAX_FREQUENCY_IN_MS = 1000;

const ElapsedAndTotalTime: React.FC<Props> = ({ songDuration, videoElement }) => {
  const [songCurrentTime, setSongCurrentTime] = useState<number>(0);

  const updateCurrentTime = useCallback(
    throttle(() => {
      setSongCurrentTime(videoElement.currentTime);
    }, ELAPSED_TIME_MAX_FREQUENCY_IN_MS),
    [setSongCurrentTime, videoElement],
  );
  useMediaElementListener(videoElement, 'timeupdate', updateCurrentTime);

  return (
    <ElapsedAndTotalTimeContainer>
      {getElapsedAndTotalTime(songCurrentTime, songDuration)}
    </ElapsedAndTotalTimeContainer>
  );
};

export default ElapsedAndTotalTime;
